import IManufacturer from '@/models/vehicle/interfaces/manufacturer.d';
import IRange from '@/models/vehicle/interfaces/range.d';
import IDerivative from '@/models/vehicle/interfaces/derivative.d';
import Results from '@/models/vehicle/results';
import VehicleStatusType from '@/enums/VehicleStatusType';
import IVehicleSearchState from './interfaces/vehicle-search-state.d';

export default class VehicleSearchState implements IVehicleSearchState {
    public manufacturers: IManufacturer[] | null = null;

    public ranges: IRange[] | null = null;

    public results: Results = new Results();

    public filteredResults: IDerivative[] = [];

    public vehicleStatusType: VehicleStatusType = VehicleStatusType.Initial;

    public moduleKey: string = '';
}
